import { useManagement } from "./use-management";
export var useSliceContent = function (entity) {
  var label = entity.label;
  var intro = entity.intro,
    content = entity.content,
    outro = entity.outro;
  var canEdit = useManagement().canEdit;
  var hasIntro = !!intro.text;
  var hasContent = !!content.text;
  var hasOutro = !!outro.text;
  return {
    entity: entity,
    canEdit: canEdit,
    hasContent: hasContent,
    hasIntro: hasIntro,
    hasOutro: hasOutro,
    label: label,
    shouldRender: hasIntro || hasContent || hasOutro || canEdit
  };
};